import Image from '../../../../Image';
import ProductOptions from '../../../show/product-form/ProductOptions';
import PropTypes from 'prop-types';
import Typography from '../../../../Typography';
import { useState } from 'react';

const ExtraItem = ({ extraItem, onSelect, selectedExtras = [] }) => {
	const [backInStockSettings, setBackInStockSettings] = useState({ show: false });

	if (!extraItem) {
		return null;
	}

	return (
		<>
			<Typography className="text-center" component="h2" variant="heading-sm">
				{extraItem.titles[0].trim()}
			</Typography>
			{extraItem.titles[1] && (
				<Typography className="text-center" component="p" variant="body">
					{extraItem.titles[1].trim()}
				</Typography>
			)}
			{extraItem.images && extraItem.images[0] && (
				<Image
					alt="Product image"
					height={102}
					src={extraItem.images[0].src}
					objectFit="contain"
					width={68}
				/>
			)}
			<ProductOptions
				centerButtons={true}
				primary={false}
				isPackedProduct={true}
				product={extraItem}
				selectedOptions={selectedExtras}
				setBackInStockSettings={setBackInStockSettings}
				setSelectedOptions={onSelect}
				showLabel={false}
			/>
			{backInStockSettings.show && (
				<div className="w-full border-2 border-secondary-darker bg-secondary/10 p-3 rounded-lg max-w-sm mx-auto my-4 text-center">
					<Typography variant="subtitle-xs" className="font-semibold text-secondary-darker grid">
						Doh! That one’s sold out. Please select another option.
					</Typography>
				</div>
			)}
		</>
	);
};

ExtraItem.propTypes = {
	extraItem: PropTypes.object,
	onSelect: PropTypes.func,
	selectedExtras: PropTypes.array,
};

export default ExtraItem;
